
import {bindPopover, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton} from "@mui/material";
import CallEndIcon from '@mui/icons-material/CallEnd';
import {useT} from "../../../i18n";
import {GridActionsCellItem} from "@mui/x-data-grid";
import {useStopTwilioCall} from "../../../client/hooks";
import {useMutation, useQueryClient} from "react-query";
import {enqueueSnackbar} from "notistack";

export default function StopTwilioCallButton({ id, onSuccess, isGrid }: { id: string; onSuccess?: () => void; isGrid?: boolean }) {
    const {t: translation} = useT("aufgaben");
    const mutate = useStopTwilioCallMutation(id, onSuccess);
    const popupState = usePopupState({
        variant: "popover",
        popupId: `call-${id}-stop`,
    });
    return (
        <>
            {isGrid ?
                <GridActionsCellItem
                  {...bindTrigger(popupState)}
                    key="stop-call"
                    icon={<CallEndIcon/>}
                    label={translation("stop-call-title")}
                    showInMenu={false}/>
                 :
                <IconButton
                {...bindTrigger(popupState)}
                aria-label="stop call"
            >
                <CallEndIcon />
            </IconButton>}
            <Dialog {...bindPopover(popupState)}>
                <DialogTitle id="alert-dialog-title">
                    {translation("stop-call-title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {translation("stop-call-description")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => popupState.close()} color="inherit">
                        {translation("abort")}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            mutate.mutate();
                            popupState.close();
                        }}
                    >
                        {translation("stop-call")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

function useStopTwilioCallMutation(id: string, onSuccess?: () => void) {
    const stopTwilioCall = useStopTwilioCall();
    const queryClient = useQueryClient();
    const {t: translation} = useT("aufgaben");
    return useMutation(
        () => {
            return stopTwilioCall(id);
        },
        {
            onSuccess: async () => {
                queryClient.invalidateQueries(["kontaktaufnahme", id]);
                queryClient.invalidateQueries(["kontakte-view"]);
                queryClient.invalidateQueries(["unteraufgaben"]);
                enqueueSnackbar(translation("stop-call-ended"), { variant: 'success' });
                if (onSuccess) {
                    onSuccess();
                }
            },
            onError: (error: any) => {
                enqueueSnackbar(
                    error?.message || translation("stop-call-error"),
                        { variant: 'error' }
                    );
            },
        }
    );
}